var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-tel-input',{ref:"phoneInput",class:`mc-profile-input-number ${!_vm.isValid && _vm.phoneNumber ? 'is-invalid' : ''}`,attrs:{"valid-characters-only":true,"autoFormat":false,"default-country":"ID","onlyCountries":['ID'],"mode":"national","invalidMsg":_vm.invalidMsg,"disabled":_vm.disabled,"input-options":{
    placeholder: _vm.placeholder,
    showDialCode: true,
    id: _vm.id,
    name: _vm.name,
    maxlength: 25,
    autofocus: false,
  }},on:{"validate":_vm.onValidate,"input":_vm.handleChange,"blur":function($event){return _vm.$emit('blur')}},nativeOn:{"keydown":function($event){return _vm.handleKeydown.apply(null, arguments)},"paste":function($event){return _vm.handlePaste.apply(null, arguments)}},model:{value:(_vm.phoneNumber),callback:function ($$v) {_vm.phoneNumber=$$v},expression:"phoneNumber"}})
}
var staticRenderFns = []

export { render, staticRenderFns }